var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var InputEventData = /* @__PURE__ */ ((InputEventData2) => {
  InputEventData2[InputEventData2["ARROW_DOWN"] = 0] = "ARROW_DOWN";
  InputEventData2[InputEventData2["ARROW_UP"] = 1] = "ARROW_UP";
  InputEventData2[InputEventData2["ARROW_LEFT"] = 2] = "ARROW_LEFT";
  InputEventData2[InputEventData2["ARROW_RIGHT"] = 3] = "ARROW_RIGHT";
  return InputEventData2;
})(InputEventData || {});
var EventType = /* @__PURE__ */ ((EventType2) => {
  EventType2["KEY_DOWN"] = "KEY_DOWN";
  return EventType2;
})(EventType || {});
var MappedKeys = /* @__PURE__ */ ((MappedKeys2) => {
  MappedKeys2["ARROW_DOWN"] = "down";
  MappedKeys2["ARROW_UP"] = "up";
  MappedKeys2["ARROW_LEFT"] = "left";
  MappedKeys2["ARROW_RIGHT"] = "right";
  MappedKeys2["ARROW_DOWN_ALT"] = "s";
  MappedKeys2["ARROW_UP_ALT"] = "w";
  MappedKeys2["ARROW_LEFT_ALT"] = "a";
  MappedKeys2["ARROW_RIGHT_ALT"] = "d";
  MappedKeys2["ARROW_DOWN_ALT2"] = "k";
  MappedKeys2["ARROW_UP_ALT2"] = "i";
  MappedKeys2["ARROW_LEFT_ALT2"] = "j";
  MappedKeys2["ARROW_RIGHT_ALT2"] = "l";
  MappedKeys2["INTERACT"] = "e";
  MappedKeys2["USE"] = "q";
  MappedKeys2["SPACE"] = "space";
  MappedKeys2["SHIFT"] = "shift";
  MappedKeys2["ESC"] = "escape";
  MappedKeys2["TILDE"] = "`";
  MappedKeys2["TAB"] = "tab";
  return MappedKeys2;
})(MappedKeys || {});
var InputEventType = /* @__PURE__ */ ((InputEventType2) => {
  InputEventType2[InputEventType2["ANY"] = 0] = "ANY";
  InputEventType2[InputEventType2["TOUCH"] = 1] = "TOUCH";
  InputEventType2[InputEventType2["KEYBOARD"] = 2] = "KEYBOARD";
  InputEventType2[InputEventType2["GAMEPAD"] = 3] = "GAMEPAD";
  InputEventType2[InputEventType2["MOUSE"] = 4] = "MOUSE";
  return InputEventType2;
})(InputEventType || {});
class KeyMapInput {
  constructor() {
    __publicField(this, "keyMap");
  }
  clone() {
    const clone = new KeyMapInput();
    clone.keyMap = new Map(this.keyMap);
    return clone;
  }
}
class InputManager {
  constructor(combineKeyMaps = true) {
    __publicField(this, "keyMap");
    __publicField(this, "keyMapsByType", {});
    __publicField(this, "changes", {});
    __publicField(this, "keyListeners", []);
    __publicField(this, "dispatchEvent", (key, keyPressed, eventType, typeIndex = 0, e) => {
      let keyMap;
      if (this.combineKeyMaps) {
        keyMap = this.keyMap;
      } else {
        if (!this.keyMapsByType[eventType]) {
          this.keyMapsByType[eventType] = [];
        }
        if (!this.keyMapsByType[eventType][typeIndex]) {
          this.keyMapsByType[eventType][typeIndex] = InputManager.buildKeyMap();
        }
        keyMap = this.keyMapsByType[eventType][typeIndex];
      }
      if (keyPressed) {
        keyMap.set(key, keyPressed);
      } else {
        keyMap.delete(key);
      }
      this.keyListeners.forEach((listener) => listener(key, keyPressed, eventType, typeIndex, e));
    });
    this.combineKeyMaps = combineKeyMaps;
    this.keyMap = InputManager.buildKeyMap();
  }
  getKeyMap(type, typeIndex = 0) {
    return this.clone(type, typeIndex);
  }
  toKeyMap(obj) {
    const keyMap = InputManager.buildKeyMap();
    for (const key in obj) {
      keyMap.set(key, obj[key]);
    }
    return keyMap;
  }
  clone(eventType, typeIndex = 0) {
    const clone = InputManager.buildKeyMap();
    let keyMap;
    if (this.combineKeyMaps || !eventType) {
      keyMap = this.keyMap;
    } else {
      if (!this.keyMapsByType[eventType]) {
        this.keyMapsByType[eventType] = [];
      }
      if (!this.keyMapsByType[eventType][typeIndex]) {
        this.keyMapsByType[eventType][typeIndex] = InputManager.buildKeyMap();
      }
      keyMap = this.keyMapsByType[eventType][typeIndex];
    }
    keyMap.forEach((value, key) => {
      clone.set(key, value);
    });
    return clone;
  }
  static buildKeyMap() {
    return /* @__PURE__ */ new Map();
  }
  addKeyListener(listener) {
    this.keyListeners.push(listener);
    return () => {
      this.keyListeners = this.keyListeners.filter((l) => l !== listener);
    };
  }
  removeKeyListener(listener) {
    this.keyListeners = this.keyListeners.filter((l) => l !== listener);
  }
  keyMapToJsonObject(keyMap) {
    const obj = {};
    keyMap.forEach((value, key) => {
      if (value) {
        obj[key] = value;
      }
    });
    return obj;
  }
  keyPressed(key, eventType, typeIndex = 0) {
    if (eventType === void 0) {
      eventType = 2;
    }
    if (this.combineKeyMaps || eventType === 0) {
      return !!this.keyMap.get(key);
    }
    if (!this.keyMapsByType[eventType]) {
      return false;
    }
    if (!this.keyMapsByType[eventType][typeIndex]) {
      return false;
    }
    return !!this.keyMapsByType[eventType][typeIndex].get(key);
  }
}
export {
  EventType,
  InputEventData,
  InputEventType,
  InputManager,
  KeyMapInput,
  MappedKeys
};
//# sourceMappingURL=InputManager.js.map
